export const sendFbqEvent = (...args: Parameters<typeof window.fbq>) => {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq(...args)
  }
}
